import React from 'react';
import { makeStyles } from '@material-ui/styles';

// // MUI Components
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import WifiOffIcon from '@material-ui/icons/WifiOff';

// // Constants
import { CONTENT } from '../../../../legacy/constants';

const useStyles = makeStyles({
  root: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
  stack: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    margin: '2rem 0',
  },
  title: {
    padding: '1rem 0',
  },
  subtitle: {
    marginBottom: '1rem',
    textAlign: 'center',
  },
  icon: {
    width: '6rem',
    height: '6rem',
  },
});

const Offline = () => {
  const { offline } = CONTENT;
  const classes = useStyles();
  return (
    <Box className={classes.root}>
      <Box className={classes.stack}>
        <WifiOffIcon className={classes.icon} />
        <Typography variant="h4" className={classes.title}>
          {offline.title}
        </Typography>
        <Typography variant="subtitle1" className={classes.subtitle}>
          {offline.subtitle}
        </Typography>
      </Box>
    </Box>
  );
};

export default Offline;



// WEBPACK FOOTER //
// ./src/views/components/Common/Offline/Offline.jsx